(function () {
  /**
   * CONFIG*/

  const MARKET_PARAM = "market";
  const STORAGE_KEY = "user_market";
  const COOKIE_KEY = "user_market";

  const MARKET_TO_CURRENCY = {
    br: "BRL",
    ao: "AOA",
  };

  function getCookie(name) {
    const m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, maxAgeSeconds = 31536000) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}`;
  }

  function getMarketFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const m = params.get(MARKET_PARAM);
    return m === "br" || m === "ao" ? m : null;
  }

  function saveMarket(market) {
    localStorage.setItem(STORAGE_KEY, market);
    setCookie(COOKIE_KEY, market);
  }

  function resolveMarket() {
    return (
      getMarketFromUrl() ||
      localStorage.getItem(STORAGE_KEY) ||
      getCookie(COOKIE_KEY)
    );
  }

  function cleanUrlMarketParam() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(MARKET_PARAM)) return;
    params.delete(MARKET_PARAM);
    const newUrl =
      window.location.pathname +
      (params.toString() ? "?" + params.toString() : "") +
      window.location.hash;
    window.history.replaceState({}, "", newUrl);
  }

  // -------- NOVA (Nova: Multi Currency Converter) --------
  // Widget atual: .bacurr-choiceDesign ... <span class="ba-chosen">BRL</span>
  function getNovaChosenCurrency() {
    return document.querySelector(".bacurr-choiceDesign .ba-chosen")?.textContent?.trim() || null;
  }

  function openNovaSelector() {
    const root = document.querySelector(".bacurr-choiceDesign");
    if (!root) return false;
    root.click();
    return true;
  }

  function clickCurrencyOption(currency) {
    // Tentativas variadas porque o DOM do app pode mudar entre temas/updates
    const candidates = [
      `.baCountry-${currency}`,
      `[class*="baCountry-${currency}"]`,
      `[data-currency="${currency}"]`,
      `[data-value="${currency}"]`,
      `[aria-label="${currency}"]`,
      `button[value="${currency}"]`,
      `li[value="${currency}"]`,
      `a[href*="${currency}"]`,
    ];

    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        return true;
      }
    }

    // Fallback: procurar qualquer elemento que contenha o texto "BRL", "USD", etc
    const all = Array.from(document.querySelectorAll("button, a, li, div, span"));
    const byText = all.find((n) => (n.textContent || "").trim() === currency);
    if (byText) {
      byText.click();
      return true;
    }

    return false;
  }

  /**
   * Força a moeda:
   * - espera o widget aparecer
   * - se já está na moeda, não faz nada
   * - abre e tenta clicar na opção
   * - confere se mudou
   */
  function forceNovaCurrency(currency) {
    const maxMs = 12000;
    const start = Date.now();

    const timer = setInterval(() => {
      const chosen = getNovaChosenCurrency();

      // 아직 não carregou o widget
      if (!chosen) {
        if (Date.now() - start > maxMs) clearInterval(timer);
        return;
      }

      // Já está certo
      if (chosen === currency) {
        clearInterval(timer);
        return;
      }

      // Tenta abrir e clicar
      openNovaSelector();
      const clicked = clickCurrencyOption(currency);

      // Se clicou, dá um tempo e valida na próxima rodada
      if (clicked) {
        // nada
      }

      // Timeout geral
      if (Date.now() - start > maxMs) clearInterval(timer);
    }, 250);
  }
function applyFooterWhatsappText(market) {
  const maxMs = 8000;
  const start = Date.now();

  const timer = setInterval(() => {
    const link = document.querySelector('a[href*="wa.me/244940880303"]');
    if (!link) {
      if (Date.now() - start > maxMs) clearInterval(timer);
      return;
    }

    link.textContent =
      market === "ao"
        ? "Fale connosco no WhatsApp"
        : "Fale conosco no WhatsApp";

    clearInterval(timer);
  }, 250);
}

function applyOriginTextByMarket(market) {
  const maxMs = 8000;
  const start = Date.now();

  const timer = setInterval(() => {
    // encontra o <p> que contém esse texto (evita depender do class enorme)
    const p = Array.from(document.querySelectorAll(".text-block p"))
      .find(el => (el.textContent || "").includes("A Paula Lino é uma Marca"));

    if (!p) {
      if (Date.now() - start > maxMs) clearInterval(timer);
      return;
    }

    if (market === "br") {
      p.textContent = "A Paula Lino é uma Marca brasileira com raízes angolanas de calçados femininos que nasceu em 2021.";
    } else {
      p.textContent = "A Paula Lino é uma Marca angolana com raízes brasileiras de calçados femininos que nasceu em 2021.";
    }

    clearInterval(timer);
  }, 250);
}

  // -------- Execução --------
  const marketFromUrl = getMarketFromUrl();
  if (marketFromUrl) {
    saveMarket(marketFromUrl);
    cleanUrlMarketParam();
  }

  const market = resolveMarket();
  if (!market) return;
  applyFooterWhatsappText(market);
  applyOriginTextByMarket(market);

  const currency = MARKET_TO_CURRENCY[market];
  if (!currency) return;

  forceNovaCurrency(currency);
})();
